import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize PostHog before React renders so session recording captures the full session.
// No-ops when REACT_APP_POSTHOG_KEY is not set (local dev without .env).
if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com',
    defaults: '2026-01-30',

    // Autocapture: clicks only (required for heatmaps — not form fills/input to avoid PII)
    autocapture: {
      event_allowlist: ['$click', '$rageclick'],
      // Never capture input values
      capture_copied_text: false,
    },

    capture_pageview: false,     // Router.js RouteTracker fires page() manually
    persistence: 'localStorage',
    person_profiles: 'identified_only',

    // Session replay — masks all user input for privacy
    session_recording: {
      maskAllInputs: true,
      maskInputOptions: { password: true },
      // Capture network requests for LLM analytics (redact auth headers)
      recordHeaders: false,
      recordBody: false,
    },

    // Heatmaps — works alongside session replay
    enable_heatmaps: true,

    // Feature flags — bootstrap to avoid UI flicker on first load
    bootstrap: {},

    // Error tracking — PostHog will receive captureException calls from ErrorBoundary
    capture_dead_clicks: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
